type Props = {
  width?: string;
  height?: string;
  strokeColor?: string;
};
const SplitPresentationIcon = (props: Props) => {
  const { width = '12', height = '12', strokeColor = '#E5E5E5' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.75 1.5H2.25C1.83579 1.5 1.5 1.83579 1.5 2.25V9.75C1.5 10.1642 1.83579 10.5 2.25 10.5H9.75C10.1642 10.5 10.5 10.1642 10.5 9.75V2.25C10.5 1.83579 10.1642 1.5 9.75 1.5Z"
        stroke={strokeColor}
        strokeLinejoin="round"
      />
      <path
        d="M1.5 4.75H10.5M1.5 4V5.5M10.5 4V5.5"
        stroke={strokeColor}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SplitPresentationIcon;
